App.ModifierGroupCardComponent = Em.Component.extend
  classNames: [ 'modifier-group-card' ]
  classNameBindings: ['modifierGroup.visible:visible']

  minMaxText: (->
    min = @get('modifierGroup.min')
    max = @get('modifierGroup.max')

    return "= #{min}" if min == max
    a = []
    a.push "≤ #{@get('modifierGroup.max')}" if @get('modifierGroup.max')
    a.push "≥ #{@get('modifierGroup.min')}" if @get('modifierGroup.min')
    a.join(' и ')
  ).property('modifierGroup.min', 'modifierGroup.max')


  linkTo: (->
    unless @get('isCombo') then 'modifier-groups.modifier-group' else 'dish-groups.dish-group'
  ).property('isCombo')
